var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"about-intd"}},[_c('div',{staticClass:"intd-box"},[_c('h3',[_vm._v(_vm._s(_vm.pageData.news_title))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageData.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-53cf747a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Public/public_intd.vue
// module id = null
// module chunks = 